import type { ApiResponse } from '../types/api';

class ApiClient {
    private baseUrl = '/api';  // assuming relative, since Running under ASP.NET

    async get<T>(url: string, options?: { headers?: Record<string, string> }): Promise<ApiResponse<T>> {
        try {
            const fullUrl = `${this.baseUrl}${url.startsWith('/') ? '' : '/'}${url}`;
            const response = await fetch(fullUrl, {
                headers: options?.headers
            });
            if (!response.ok) {
                const errorData = await response.json().catch(() => ({ error: `HTTP ${response.status}: ${response.statusText}` }));
                return errorData;
            }
            const data = await response.json();
            return data as ApiResponse<T>;
        } catch (error: unknown) {
            return { error: error instanceof Error ? error.message : 'Unknown error' };
        }
    }

    async post<U, T>(url: string, data: U, options?: { headers?: Record<string, string> }): Promise<ApiResponse<T>> {
        try {
            const fullUrl = `${this.baseUrl}${url.startsWith('/') ? '' : '/'}${url}`;
            const response = await fetch(fullUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    ...options?.headers,
                },
                body: JSON.stringify(data),
            });
            if (!response.ok) {
                const errorData = await response.json().catch(() => ({ error: `HTTP ${response.status}: ${response.statusText}` }));
                return errorData;
            }
            const result = await response.json();
            return result as ApiResponse<T>;
        } catch (error: unknown) {
            return { error: error instanceof Error ? error.message : 'Unknown error' };
        }
    }

    async put<U, T>(url: string, data: U, options?: { headers?: Record<string, string> }): Promise<ApiResponse<T>> {
        try {
            const fullUrl = `${this.baseUrl}${url.startsWith('/') ? '' : '/'}${url}`;
            const response = await fetch(fullUrl, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    ...options?.headers,
                },
                body: JSON.stringify(data),
            });
            if (!response.ok) {
                const errorData = await response.json().catch(() => ({ error: `HTTP ${response.status}: ${response.statusText}` }));
                return errorData;
            }
            const result = await response.json();
            return result as ApiResponse<T>;
        } catch (error: unknown) {
            return { error: error instanceof Error ? error.message : 'Unknown error' };
        }
    }

    async delete<T>(url: string, options?: { headers?: Record<string, string> }): Promise<ApiResponse<T>> {
        try {
            const fullUrl = `${this.baseUrl}${url.startsWith('/') ? '' : '/'}${url}`;
            const response = await fetch(fullUrl, {
                method: 'DELETE',
                headers: options?.headers,
            });
            if (!response.ok) {
                const errorData = await response.json().catch(() => ({ error: `HTTP ${response.status}: ${response.statusText}` }));
                return errorData;
            }
            const result = response.bodyUsed ? await response.json() : {};
            return result as ApiResponse<T>;
        } catch (error: unknown) {
            return { error: error instanceof Error ? error.message : 'Unknown error' };
        }
    }
}

const apiClient = new ApiClient();

export default apiClient;
